/* eslint-disable */
export { DocLayout as default } from '../components';